var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPhotograph(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_photograph") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_photograph",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.600000024
  }, /*#__PURE__*/React.createElement("g", {
    id: "baseline-photo_camera-24px-(1)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#D2DAE2",
    fillRule: "nonzero",
    cx: 40,
    cy: 40,
    r: 10.6666667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,6.66666667 L23.9,13.3333333 L13.3333333,13.3333333 C9.66666667,13.3333333 6.66666667,16.3333333 6.66666667,20 L6.66666667,60 C6.66666667,63.6666667 9.66666667,66.6666667 13.3333333,66.6666667 L66.6666667,66.6666667 C70.3333333,66.6666667 73.3333333,63.6666667 73.3333333,60 L73.3333333,20 C73.3333333,16.3333333 70.3333333,13.3333333 66.6666667,13.3333333 L56.1,13.3333333 L50,6.66666667 L30,6.66666667 Z M40,56.6666667 C30.8,56.6666667 23.3333333,49.2 23.3333333,40 C23.3333333,30.8 30.8,23.3333333 40,23.3333333 C49.2,23.3333333 56.6666667,30.8 56.6666667,40 C56.6666667,49.2 49.2,56.6666667 40,56.6666667 Z",
    id: "Shape",
    fill: "#D2DAE2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "0 0 80 0 80 80 0 80"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPhotograph);
export default __webpack_public_path__ + "sanerret-static/media/ic_photograph.1e45ecf836e841fc29a44274d2ccd4cc.svg";
export { ForwardRef as ReactComponent };